export default function TaskModal({
  isOpen,
  editingTaskId,
  title,
  description,
  taskDate,
  titleInputRef,
  descriptionTextareaRef,
  onTitleChange,
  onDescriptionChange,
  onDateChange,
  onInsertBullet,
  onInsertCheckbox,
  onInsertTitle,
  onSubmit,
  onClose,
}) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(event) => event.stopPropagation()}>
        <h2>{editingTaskId !== null ? 'Modifier la tâche' : 'Nouvelle tâche'}</h2>

        <form onSubmit={onSubmit} className="task-form">
          <input ref={titleInputRef} type="text" placeholder="Titre" value={title} onChange={onTitleChange} />

          <div className="description-editor">
            <div className="description-toolbar">
              <button type="button" className="description-bullet-btn" onClick={onInsertBullet}>• Puce</button>
              <button type="button" className="description-checkbox-btn" onClick={onInsertCheckbox}>☐ Case</button>
              <button
                type="button"
                className="description-copy-title-btn"
                onClick={onInsertTitle}
                disabled={!title.trim()}
                title={title.trim() ? 'Copier le titre dans la description' : 'Saisis d’abord un titre'}
              >
                ↓ Titre
              </button>
            </div>

            <textarea
              ref={descriptionTextareaRef}
              placeholder="Description"
              value={description}
              onChange={onDescriptionChange}
            />
          </div>

          <input type="date" value={taskDate} onChange={onDateChange} />

          <div className="modal-actions">
            <button type="submit">{editingTaskId !== null ? 'Enregistrer' : 'Ajouter'}</button>
            <button type="button" onClick={onClose}>Annuler</button>
          </div>
        </form>
      </div>
    </div>
  );
}
